import type {ApiResponseData} from '@frontend/types/AppTypes'
import type {UserAccountFlags} from '@frontend/types/GlobalStores'
import type {
    UserData,
    UserDataForAdvancePayment,
    UserInfoResponseData,
} from '@frontend/types/User'
import {handleMessageFromResponse} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

// Получение данных пользователя.
export const UserAccountApi = {

    // Запрос данных авторизованного пользователя.
    async getUserData(
        abortController?: AbortController,
        requestConfig?: RequestInit
    ): Promise<UserData> {
        return ApiRequestService
            .get<UserInfoResponseData>(
                '/v1/user',
                undefined,
                requestConfig,
                abortController
            )
            .then(response => {
                handleMessageFromResponse(response)
                return response.data.user
            })
    },

    // Запрос данных авторизованного пользователя.
    async getUserDataForAdvancePayment(
        this: void,
        ignoreCache: boolean = false,
        abortController?: AbortController
    ): Promise<UserDataForAdvancePayment> {
        return ApiRequestService
            .get<GetUserInfoForAdvancePaymentResponseData>(
                '/v1/user',
                {
                    forAdvance: true,
                    ignoreCache,
                },
                undefined,
                abortController
            )
            .then(response => {
                handleMessageFromResponse(response)
                return response.data.user
            })
    },

    // Запрос состояния различных флагов аккаунта (новые сообщения, уведомления и т.п).
    async getFlags(
        abortController?: AbortController,
        requestConfig?: RequestInit
    ): Promise<UserAccountFlags> {
        return ApiRequestService
            .get<GetUserAccountFlagsResponseData>(
                '/v1/user/flags',
                undefined,
                requestConfig,
                abortController
            )
            .then(response => response.data.flags)
    },
}

interface GetUserInfoForAdvancePaymentResponseData extends ApiResponseData {
    user: UserDataForAdvancePayment
}

interface GetUserAccountFlagsResponseData extends ApiResponseData {
    flags: UserAccountFlags
}
